(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cheat-code-direct-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scanView = 'cheat-code-discovery-v3';
    function initialize(scope = document) {
      scope.querySelectorAll('[data-cc-landing-v3]').forEach(page => {
        if (page.dataset.ccV3Initialized === 'true') return;
        page.dataset.ccV3Initialized = 'true';
        const current = new URL(window.location.href);
        const themeId = String(window.Shopify?.theme?.id || current.searchParams.get('preview_theme_id') || '');
        if (themeId === '206959575379') page.querySelectorAll('a[data-cc-preview-link]').forEach(link => {
          const target = new URL(link.getAttribute('href'), window.location.href);
          if (target.origin !== current.origin || target.searchParams.get('view') !== scanView) return;
          target.searchParams.set('preview_theme_id', themeId);
          link.setAttribute('href', target.pathname + target.search + target.hash);
        });
        const event = (name, position = null) => document.dispatchEvent(new CustomEvent('cheat-code:event', {
          detail: { name, funnel: 'direct', version: 'direct-v3', currency: 'EUR', value: 24.95, position, development: true }
        }));
        event('LandingView');
        page.querySelectorAll('[data-cc-tool]').forEach(tool => {
          const field = tool.querySelector('[data-cc-tool-text]');
          const original = tool.querySelector('[data-cc-tool-original]');
          const status = tool.querySelector('[data-cc-copy-status]');
          const copy = tool.querySelector('[data-cc-copy]');
          const reset = tool.querySelector('[data-cc-reset]');
          if (!field || !original || !status || !copy || !reset) return;
          copy.addEventListener('click', async () => {
            try {
              if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
              await navigator.clipboard.writeText(field.value);
              status.textContent = page.dataset.ccCopied;
            } catch {
              field.focus(); field.select();
              status.textContent = page.dataset.ccCopyFallback;
            }
          });
          reset.addEventListener('click', () => {
            field.value = original.content ? original.content.textContent : original.textContent;
            status.textContent = ''; field.focus();
          });
        });
        page.addEventListener('click', e => {
          const control = e.target.closest('[data-cc-event="OfferCTA"]');
          if (page.dataset.ccCheckoutEnabled !== 'true' || !control || control.disabled || control.dataset.ccCheckout !== 'enabled') return;
          event('OfferCTA', control.dataset.ccPosition);
        });
        const sticky = page.querySelector('.cc-sticky');
        const hero = page.querySelector('.cc-hero');
        const footer = page.querySelector('.cc-footer');
        if (!sticky || !hero || !footer || !('IntersectionObserver' in window)) return;
        let heroVisible = true;
        let footerVisible = false;
        const offer = page.querySelector('.cc-offer-card');
        const final = page.querySelector('.cc-final');
        let offerVisible = false;
        let finalVisible = false;
        let reading = false;
        let focusing = false;
        const updateSticky = () => {
          const visible = !heroVisible && !footerVisible && !offerVisible && !finalVisible && !reading && !focusing;
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', String(!visible));
          sticky.inert = !visible;
        };
        page.addEventListener('toggle', () => {
          reading = Boolean(page.querySelector('details[open]'));
          updateSticky();
        }, true);
        page.addEventListener('focusin', e => {
          focusing = Boolean(e.target.closest?.('a, summary, input, textarea, button')) && !e.target.closest?.('.cc-sticky');
          updateSticky();
        });
        page.addEventListener('focusout', () => { focusing = false; updateSticky(); });
        const observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.target === hero) heroVisible = entry.isIntersecting;
            if (entry.target === footer) footerVisible = entry.isIntersecting;
            if (entry.target === offer) offerVisible = entry.isIntersecting;
            if (entry.target === final) finalVisible = entry.isIntersecting;
          }
          updateSticky();
        });
        observer.observe(hero);
        observer.observe(footer);
        if (offer) observer.observe(offer);
        if (final) observer.observe(final);
        const section = page.closest('.shopify-section') || page;
        section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', e => initialize(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cheat-code-direct"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const allowedAngles = new Set(['job_loss', 'self_employed', 'scam', 'new_parent']);
    function initialize(scope = document) {
      scope.querySelectorAll('[data-cc-landing]').forEach(page => {
        if (page.dataset.ccInitialized === 'true') return;
        page.dataset.ccInitialized = 'true';
        const angle = allowedAngles.has(page.dataset.ccAngle) ? page.dataset.ccAngle : 'job_loss';
        const event = (name, position = null) => document.dispatchEvent(new CustomEvent('cheat-code:event', {
          detail: { name, angle, funnel: 'direct', version: 'direct-v2-human', currency: 'EUR', value: 24.95, position, development: true }
        }));
        event('LandingView');
        page.querySelectorAll('[data-cc-tool]').forEach(tool => {
          const field = tool.querySelector('[data-cc-tool-text]');
          const original = tool.querySelector('[data-cc-tool-original]');
          const status = tool.querySelector('[data-cc-copy-status]');
          const copy = tool.querySelector('[data-cc-copy]');
          const reset = tool.querySelector('[data-cc-reset]');
          if (!field || !original || !status || !copy || !reset) return;
          copy.addEventListener('click', async () => {
            try {
              if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
              await navigator.clipboard.writeText(field.value);
              status.textContent = page.dataset.ccCopied;
            } catch {
              field.focus(); field.select();
              status.textContent = page.dataset.ccCopyFallback;
            }
          });
          reset.addEventListener('click', () => {
            field.value = original.content ? original.content.textContent : original.textContent;
            status.textContent = ''; field.focus();
          });
        });
        page.addEventListener('click', e => {
          const control = e.target.closest('[data-cc-event="OfferCTA"]');
          if (page.dataset.ccCheckoutEnabled !== 'true' || !control || control.disabled || control.dataset.ccCheckout !== 'enabled') return;
          event('OfferCTA', control.dataset.ccPosition);
        });
        const sticky = page.querySelector('.cc-sticky');
        const hero = page.querySelector('.cc-hero');
        const footer = page.querySelector('.cc-footer');
        if (!sticky || !hero || !footer || !('IntersectionObserver' in window)) return;
        let heroVisible = true;
        let footerVisible = false;
        const offer = page.querySelector('.cc-offer-card');
        const final = page.querySelector('.cc-final');
        let offerVisible = false;
        let finalVisible = false;
        let reading = false;
        let focusing = false;
        const updateSticky = () => {
          const visible = !heroVisible && !footerVisible && !offerVisible && !finalVisible && !reading && !focusing;
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', String(!visible));
          sticky.inert = !visible;
        };
        page.addEventListener('toggle', () => {
          reading = Boolean(page.querySelector('details[open]'));
          updateSticky();
        }, true);
        page.addEventListener('focusin', e => {
          focusing = Boolean(e.target.closest?.('a, summary, input, textarea, button')) && !e.target.closest?.('.cc-sticky');
          updateSticky();
        });
        page.addEventListener('focusout', () => { focusing = false; updateSticky(); });
        const observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.target === hero) heroVisible = entry.isIntersecting;
            if (entry.target === footer) footerVisible = entry.isIntersecting;
            if (entry.target === offer) offerVisible = entry.isIntersecting;
            if (entry.target === final) finalVisible = entry.isIntersecting;
          }
          updateSticky();
        });
        observer.observe(hero);
        observer.observe(footer);
        if (offer) observer.observe(offer);
        if (final) observer.observe(final);
        const section = page.closest('.shopify-section') || page;
        section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', e => initialize(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cheat-code-scan"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  function decodeThemeText(value) {
    if (typeof value !== 'string') return '';
    const named = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'" };
    return value.replace(/&(amp|lt|gt|quot|apos|#\d{1,8}|#x[\da-f]{1,6});/gi, (entity, name) => {
      const normalized = name.toLowerCase();
      if (Object.hasOwn(named, normalized)) return named[normalized];
      const hexadecimal = normalized.startsWith('#x');
      const code = Number.parseInt(normalized.slice(hexadecimal ? 2 : 1), hexadecimal ? 16 : 10);
      return code > 0 && code <= 0x10ffff && !(code >= 0xd800 && code <= 0xdfff) ? String.fromCodePoint(code) : entity;
    });
  }
  function normalizeCopy(copy) {
    return Object.fromEntries(Object.entries(copy).map(([key, value]) => [key, decodeThemeText(value)]));
  }
  function validateConfig(config) {
    const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
    const unique = values => Array.isArray(values) && values.length > 0 && new Set(values).size === values.length;
    if (!record(config) || !record(config.copy) || !record(config.scoring) || !record(config.framing)) return false;
    const hasCopy = key => typeof key === 'string' && typeof config.copy[key] === 'string' && config.copy[key].trim().length > 0;
    const questionIds = ['situation', 'life_stage', 'housing', 'preparedness', 'purpose'];
    if (!Array.isArray(config.questions) || config.questions.length !== 5 || !Array.isArray(config.areas) || config.areas.length !== 6 || !Array.isArray(config.insights)) return false;
    for (const [index, question] of config.questions.entries()) {
      if (!record(question) || question.id !== questionIds[index] || question.type !== (index === 3 ? 'multiple' : 'single') || !hasCopy(question.label) || !hasCopy(question.hint)) return false;
      if (!Array.isArray(question.options) || !question.options.length || !question.options.every(option => record(option) && typeof option.id === 'string' && option.id && hasCopy(option.label)) || !unique(question.options.map(option => option.id))) return false;
    }
    const areas = config.areas.map(area => area?.id);
    if (!unique(areas) || !config.areas.every(area => record(area) && typeof area.id === 'string' && hasCopy(area.title) && hasCopy(area.description))) return false;
    if (!unique(config.scoring.tieOrder) || config.scoring.tieOrder.length !== areas.length || !config.scoring.tieOrder.every(id => areas.includes(id))) return false;
    if (!Number.isInteger(config.scoring.interestWeight) || config.scoring.interestWeight < 0 || !config.questions[3].options.every(option => areas.includes(option.id))) return false;
    for (const question of config.questions.slice(0, 3)) {
      if (!record(config.scoring[question.id])) return false;
      for (const option of question.options) {
        const weights = config.scoring[question.id][option.id];
        if (!record(weights) || !Object.entries(weights).every(([area, score]) => areas.includes(area) && Number.isInteger(score) && score >= 0)) return false;
      }
    }
    if (!config.questions[4].options.every(option => {
      const framing = config.framing[option.id];
      return record(framing) && hasCopy(framing.copy) && typeof framing.segment === 'string' && /^purpose_[a-z_]+$/.test(framing.segment);
    })) return false;
    const profileIds = config.questions[0].options.map(option => option.id);
    const lifeStages = config.questions[1].options.map(option => option.id);
    const scopedTo = (value, allowed) => value === undefined || (unique(value) && value.every(id => allowed.includes(id)));
    const sourceUrl = value => typeof value === 'string' && /^https:\/\/[^\s]+$/.test(value);
    if (!config.insights.every(insight => record(insight) && typeof insight.id === 'string' && /^CC-\d{3}$/.test(insight.entryId) && insight.entryId !== 'CC-025'
      && areas.includes(insight.area) && scopedTo(insight.profiles, profileIds) && scopedTo(insight.lifeStages, lifeStages)
      && ['title', 'body', 'evidence', 'escalation', 'region', 'sourceLabel'].every(key => hasCopy(insight[key]))
      && Array.isArray(insight.actions) && insight.actions.length >= 1 && insight.actions.length <= 3 && insight.actions.every(hasCopy)
      && typeof insight.reviewed === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(insight.reviewed) && sourceUrl(insight.sourceUrl)
      && (insight.sources === undefined || (Array.isArray(insight.sources) && insight.sources.every(source => record(source) && sourceUrl(source.url) && hasCopy(source.label)))))) return false;
    if (new Set(config.insights.map(insight => insight.id)).size !== config.insights.length) return false;
    return ['progress', 'completed', 'next', 'finish', 'required_single', 'required_multiple', 'evidence_label', 'source_review', 'chosen_reason', 'context_reason', 'default_reason', 'insight_details', 'insight_details_more', 'insight_second', 'insights_title', 'no_insights_title'].every(hasCopy);
  }
  function validateAnswer(question, answer) {
    const ids = new Set(question.options.map(option => option.id));
    if (question.type === 'multiple') return Array.isArray(answer) && answer.length > 0 && answer.length <= ids.size && new Set(answer).size === answer.length && answer.every(id => ids.has(id));
    return typeof answer === 'string' && ids.has(answer);
  }
  function validateAnswers(config, answers) {
    return config.questions.length === 5 && config.questions.every(question => validateAnswer(question, answers[question.id]));
  }
  function matchAreas(config, answers) {
    if (!validateAnswers(config, answers)) throw new Error('Incomplete or invalid Scan answers');
    const scores = Object.fromEntries(config.areas.map(area => [area.id, 0]));
    for (const question of ['situation', 'life_stage', 'housing']) {
      const weights = config.scoring[question][answers[question]];
      for (const [area, score] of Object.entries(weights)) scores[area] += score;
    }
    const contextScores = { ...scores };
    for (const area of answers.preparedness) scores[area] += config.scoring.interestWeight;
    const order = config.scoring.tieOrder;
    return config.areas.map(area => ({ ...area, score: scores[area.id], reason: answers.preparedness.includes(area.id) ? 'chosen_reason' : contextScores[area.id] > 0 ? 'context_reason' : 'default_reason' }))
      .sort((a, b) => b.score - a.score || order.indexOf(a.id) - order.indexOf(b.id)).slice(0, 3);
  }
  function selectInsights(config, answers, areas) {
    const areaIds = areas.map(area => area.id);
    return config.insights.filter(insight => areaIds.includes(insight.area) && (!insight.profiles || insight.profiles.includes(answers.situation)) && (!insight.lifeStages || insight.lifeStages.includes(answers.life_stage)))
      .sort((a, b) => areaIds.indexOf(a.area) - areaIds.indexOf(b.area) || a.id.localeCompare(b.id)).slice(0, 2);
  }
  function areaReason(config, answers, area, copy = config.copy) {
    if (area.reason !== 'context_reason') return copy[area.reason];
    const contributors = config.questions.slice(0, 3).map(question => ({
      weight: config.scoring[question.id][answers[question.id]][area.id] || 0,
      label: question.options.find(option => option.id === answers[question.id]).label
    })).sort((a, b) => b.weight - a.weight);
    return copy.context_reason.replace('{answer}', copy[contributors[0].label]);
  }
  function buildResult(config, answers) {
    const areas = matchAreas(config, answers);
    return { areas, insights: selectInsights(config, answers, areas), framing: config.framing[answers.purpose] };
  }
  function createSession(config, emit = () => {}) {
    let answers = {};
    let index = 0;
    let phase = 'intro';
    const sent = new Set();
    const event = (name, extra = {}, key = name) => {
      if (sent.has(key)) return;
      sent.add(key);
      emit({ name, funnel: 'scan', version: config.version, currency: 'EUR', value: 24.95, development: true, ...extra });
    };
    const snapshot = () => ({ phase, index, answers: Object.fromEntries(Object.entries(answers).map(([key, value]) => [key, Array.isArray(value) ? [...value] : value])) });
    return {
      snapshot,
      start({ passive = false } = {}) {
        if (phase !== 'intro') return false;
        phase = 'question'; index = 0;
        if (!passive) event('QuizStart');
        return true;
      },
      choose(answer) {
        if (phase !== 'question') return false;
        const question = config.questions[index];
        if (!validateAnswer(question, answer) && !(question.type === 'multiple' && Array.isArray(answer) && answer.length === 0)) return false;
        if (validateAnswer(question, answer)) event('QuizStart');
        answers[question.id] = Array.isArray(answer) ? [...answer] : answer;
        return true;
      },
      advance(answer) {
        if (phase !== 'question') return false;
        const question = config.questions[index];
        if (!validateAnswer(question, answer)) return false;
        event('QuizStart');
        answers[question.id] = Array.isArray(answer) ? question.options.map(option => option.id).filter(id => answer.includes(id)) : answer;
        event('QuizQuestionComplete', { question: index + 1 }, `question-${index}`);
        if (index < config.questions.length - 1) { index += 1; return true; }
        phase = 'result';
        const segment = config.framing[answers.purpose].segment;
        event('QuizComplete', { segment });
        event('ResultView', { segment });
        return true;
      },
      back() {
        if (phase !== 'question' || index === 0) return false;
        index -= 1; return true;
      },
      edit() {
        if (phase !== 'result') return false;
        phase = 'question'; index = 0; return true;
      },
      reset() { answers = {}; index = 0; phase = 'intro'; sent.clear(); },
      result() { return phase === 'result' ? buildResult(config, answers) : null; }
    };
  }
  const api = Object.freeze({ decodeThemeText, normalizeCopy, validateConfig, validateAnswer, validateAnswers, matchAreas, selectInsights, areaReason, buildResult, createSession });
  globalThis.CheatCodeScan = api;
  if (typeof document === 'undefined') return;
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text !== undefined) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  function mount(page) {
    if (page.dataset.ccInitialized === 'true') return;
    const configNode = page.querySelector('[data-cc-scan-config]');
    let config;
    try { config = JSON.parse(configNode?.textContent); } catch { return; }
    if (!validateConfig(config)) return;
    page.dataset.ccInitialized = 'true';
    const copy = normalizeCopy(config.copy);
    const intro = page.querySelector('[data-cc-scan-intro]');
    const form = page.querySelector('[data-cc-scan-form]');
    const result = page.querySelector('[data-cc-scan-result]');
    const field = page.querySelector('[data-cc-scan-field]');
    const error = page.querySelector('[data-cc-scan-error]');
    const progress = page.querySelector('[data-cc-scan-progress]');
    const progressLabel = page.querySelector('[data-cc-scan-progress-label]');
    const back = page.querySelector('[data-cc-scan-back]');
    const next = page.querySelector('[data-cc-scan-next]');
    const session = createSession(config, detail => document.dispatchEvent(new CustomEvent('cheat-code:event', { detail })));
    const focus = node => node.focus({ preventScroll: false });
    function renderQuestion(moveFocus = true) {
      const state = session.snapshot();
      const question = config.questions[state.index];
      const current = state.answers[question.id];
      const legend = element('legend', copy[question.label]);
      legend.tabIndex = -1;
      const hint = element('p', copy[question.hint], 'cc-scan-question-hint');
      hint.id = `${page.id}-hint`;
      field.setAttribute('aria-describedby', hint.id);
      field.removeAttribute('aria-invalid');
      field.replaceChildren(legend, hint);
      const options = element('div', undefined, 'cc-scan-options');
      for (const option of question.options) {
        const label = element('label', undefined, 'cc-scan-option');
        const input = element('input');
        input.type = question.type === 'multiple' ? 'checkbox' : 'radio';
        input.name = question.id;
        input.value = option.id;
        input.checked = question.type === 'multiple' ? Boolean(current?.includes(option.id)) : current === option.id;
        label.append(input, element('span', copy[option.label]));
        options.append(label);
      }
      field.append(options);
      progress.value = state.index;
      progressLabel.textContent = copy.progress.replace('{current}', state.index + 1).replace('{total}', config.questions.length);
      back.disabled = state.index === 0;
      next.textContent = state.index === 4 ? copy.finish : copy.next;
      error.textContent = '';
      error.hidden = true;
      page.querySelector('[data-cc-scan-state-title]').textContent = copy[question.label];
      if (moveFocus) focus(legend);
    }
    function renderResult() {
      const data = session.result();
      page.dataset.ccSegment = data.framing.segment;
      progress.value = 5;
      progressLabel.textContent = copy.completed;
      page.querySelector('[data-cc-scan-framing]').textContent = copy[data.framing.copy];
      const areas = page.querySelector('[data-cc-scan-areas]');
      areas.replaceChildren(...data.areas.map((area, index) => {
        const item = element('li', undefined, 'cc-scan-area');
        const number = element('span', String(index + 1).padStart(2, '0'), 'cc-scan-area-number');
        number.setAttribute('aria-hidden', 'true');
        item.append(number, element('h3', copy[area.title]), element('p', areaReason(config, session.snapshot().answers, area, copy), 'cc-scan-area-reason'));
        return item;
      }));
      const insights = page.querySelector('[data-cc-scan-insights]');
      const sources = (container, insight) => {
        for (const source of insight.sources || []) {
          const additional = element('a', copy[source.label], 'cc-scan-source');
          additional.href = source.url;
          additional.target = '_blank'; additional.rel = 'noopener noreferrer';
          container.append(additional);
        }
      };
      const insightCard = (insight, secondary = false) => {
        const item = element('article', undefined, 'cc-scan-insight');
        item.dataset.ccInsight = insight.entryId;
        const actions = element('ol');
        insight.actions.forEach(action => actions.append(element('li', copy[action])));
        const link = element('a', copy[insight.sourceLabel], 'cc-scan-source');
        link.href = insight.sourceUrl;
        link.target = '_blank'; link.rel = 'noopener noreferrer';
        const meta = element('p', undefined, 'cc-scan-source-meta');
        const time = element('time', insight.reviewed);
        time.dateTime = insight.reviewed;
        meta.append(element('span', `${copy[insight.region]} · ${copy.source_review}: `), time);
        if (secondary) item.append(element('p', copy.insight_second, 'cc-scan-eyebrow'));
        item.append(element('h3', copy[insight.title]), element('p', copy[insight.body]), actions, element('p', copy[insight.escalation], 'cc-scan-insight-note'), link, meta);
        if (secondary) {
          item.append(element('p', `${copy.evidence_label}: ${copy[insight.evidence]}`));
          sources(item, insight);
        }
        return item;
      };
      insights.replaceChildren();
      if (data.insights.length) {
        const primary = data.insights[0];
        insights.append(insightCard(primary));
        const details = element('details', undefined, 'cc-scan-insight-depth');
        details.append(element('summary', data.insights.length > 1 ? copy.insight_details_more : copy.insight_details));
        const evidence = element('div', undefined, 'cc-scan-evidence');
        evidence.append(element('p', `${copy.evidence_label}: ${copy[primary.evidence]}`));
        sources(evidence, primary);
        details.append(evidence);
        if (data.insights[1]) details.append(insightCard(data.insights[1], true));
        insights.append(details);
      }
      page.querySelector('[data-cc-scan-no-insights]').hidden = data.insights.length > 0;
      page.querySelector('[data-cc-scan-insights-title]').textContent = data.insights.length ? copy.insights_title : copy.no_insights_title;
      page.querySelector('[data-cc-scan-insights-intro]').hidden = data.insights.length === 0;
      focus(page.querySelector('[data-cc-scan-result-title]'));
    }
    function render(moveFocus = true) {
      const { phase, index } = session.snapshot();
      page.dataset.ccPhase = phase;
      page.dataset.ccQuestion = phase === 'question' ? String(index + 1) : '';
      intro.hidden = phase !== 'question' || index !== 0;
      page.querySelector('[data-cc-scan-question-panel]').hidden = phase !== 'question';
      form.hidden = phase !== 'question';
      result.hidden = phase !== 'result';
      page.querySelector('[data-cc-scan-state-title]').hidden = phase !== 'question' || index === 0;
      page.querySelector('[data-cc-scan-progress-wrap]').hidden = phase !== 'question';
      if (phase !== 'result') delete page.dataset.ccSegment;
      if (phase === 'question') renderQuestion(moveFocus);
      else if (phase === 'result') renderResult();
    }
    const abort = new AbortController();
    const listen = (node, name, handler) => node.addEventListener(name, handler, { signal: abort.signal });
    listen(back, 'click', () => { if (session.back()) render(); });
    listen(form, 'submit', event => {
      event.preventDefault();
      const question = config.questions[session.snapshot().index];
      const checked = [...field.querySelectorAll('input:checked')].map(input => input.value);
      const answer = question.type === 'multiple' ? checked : checked[0];
      if (session.advance(answer)) render();
      else {
        error.textContent = copy[question.type === 'multiple' ? 'required_multiple' : 'required_single'];
        error.hidden = false;
        field.setAttribute('aria-invalid', 'true');
        field.setAttribute('aria-describedby', `${page.id}-hint ${error.id}`);
        focus(field.querySelector('input'));
      }
    });
    listen(field, 'change', () => {
      const question = config.questions[session.snapshot().index];
      const checked = [...field.querySelectorAll('input:checked')].map(input => input.value);
      session.choose(question.type === 'multiple' ? checked : checked[0]);
      error.hidden = true; error.textContent = ''; field.removeAttribute('aria-invalid'); field.setAttribute('aria-describedby', `${page.id}-hint`);
    });
    listen(page.querySelector('[data-cc-scan-edit]'), 'click', () => { if (session.edit()) render(); });
    listen(page.querySelector('[data-cc-scan-reset]'), 'click', () => { session.reset(); session.start({ passive: true }); render(); });
    const wrapper = page.closest('.shopify-section') || page;
    wrapper.addEventListener('shopify:section:unload', () => { session.reset(); abort.abort(); delete page.dataset.ccInitialized; }, { once: true });
    page.querySelector('[data-cc-scan-fallback]').hidden = true;
    page.querySelector('[data-cc-scan-app]').hidden = false;
    session.start({ passive: true });
    render(false);
    document.dispatchEvent(new CustomEvent('cheat-code:event', { detail: { name: 'LandingView', funnel: 'scan', version: config.version, currency: 'EUR', value: 24.95, development: true } }));
  }
  function initialize(scope = document) { scope.querySelectorAll('[data-cc-scan]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
